// NPM Modules
import React from 'react';
import { Link } from 'react-router';
import Spinner from 'react-spin';

// Modules
import Firebase from '../modules/FirebaseApp';
import '../styles/recipedia.css';

// Get URL Params
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

class VerifyEmail extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      emailVerified: false
    };
  }

  componentWillMount() {
    // Get the one-time email verify code from the query parameter.
    const actionCode = getUrlParameter('oobCode');

    Firebase.auth().applyActionCode(actionCode).then(() => {
      // Email Verified
      this.setState({
        emailVerified: true
      });
    })
    .catch((error) => {
      // Email Verfication Error
      this.setState({
        emailVerified: false,
        emailVerificationError: error
      });
    });
  }

  renderEmailVerification() {
    const emailVerified = this.state.emailVerified;
    const emailVerificationError = this.state.emailVerificationError;

    // Email Successfully Verified
    if (emailVerified === true) {
      return (
        <div>
          <h2 className="white">Congratulations! - You’re ready to use Recipedia!</h2>
          <br />
          <h5 className="white">Thank you – you’ve successfully verified your Recipedia account. You can now use the Recipedia Skill on your Amazon Alexa enabled device. For more details about the Skill, click <a className="recipedia-link" href="http://www.recipedia.com/" target="_blank">here</a>.</h5>
          <br />
          <h3 className="white">Happy Cooking!</h3>
        </div>
      );
    }
    // Email Verification Error
    else if (emailVerificationError) {
      return (
        <div>
          <h2 className="white">Email Verification Failed <span>😿</span></h2>
          <div className="alert alert-danger">{this.state.emailVerificationError.message}</div>
          <h5>Please <a className="recipedia-link" href="http://alexa.amazon.co.uk/">Re-enable the Skill</a> </h5>
        </div>
      );
    }
    // Email Verification in Progress
    else {
      const spinCfg = {
        width: 12,
        radius: 35,
        color: '#00c1e0',
        position: 'fixed'
      };
      return <Spinner config={spinCfg} />;
    }
  }

  render() {
    return (
      <div className="main">
        <div id="top" className="landing-main">
          <div className="container text-vertical-center">
            <center><img src="https://s3.eu-west-2.amazonaws.com/recipedia/recipedia-logo.jpeg" className="recipedia-logo img-responsive" alt="Recipedia Logo"></img></center>
            <div className="row">
              <div className="col-xs-8 col-xs-offset-2">
                {this.renderEmailVerification()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

};

export default VerifyEmail;



// WEBPACK FOOTER //
// ./src/components/VerifyEmail.js